/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { get } from "lodash";
import systemAlert from "../../../utils/systemAlert";
import { viewLoading } from "../../../utils/loading";
import useForm from "../../../hooks/useForm";
import { isEmpty } from "../../../utils/lodashExtend";
import Modal, { ModalHeader } from "../../Modal";
import Icon from "../../Icon";
import Form from "../../Form";
import SingoSettingIcon from "../../../assets/images/work-schedule/work-special-icon.svg";
import { isFunction } from "lodash";
import { toast } from "../../../utils/toast";
import { createFinanceAccountSub, putFinanceAccountSub } from "../../../apis/tax-portal/financeAccountSub";
import { shallowEqual, useSelector } from "react-redux";


const defaultForm = {
  userId: '',
  userPw: '',
  employeeIdx: '',
  // financeAccountIdx 
  // companyIdx 
};


const TaxAccountSubHometax = ({
  open,
  setOpen,
  mode,
  setMode,
  formData,
  setFormData,
  submit,
  accountInfo,
}) => {
  const {
    employees,
  } = useSelector(
    (store) => ({
      employees: store.Data.employees,
    }),
    shallowEqual
  );
  const [buttons, setButtons] = useState([]);

  const reset = () => {
    setMode('create');
    resetForm(defaultForm);
  };

  const close = (e) => {
    if (e) {
      e.preventDefault();
    }
    setFormData && setFormData(null);
    setOpen(false);
    reset();
  };

  const [fields] = useState([
    {
      title: '홈택스 아이디',
      key: "userId",
      type: 'input',
      required: true,
    },
    {
      title: '홈택스 패스워드',
      key: "userPw",
      type: 'password',
      required: true,
    },
    {
      title: '직원선택',
      key: "employee",
      type: 'searchemployee',
      isSingle: true
    },
  ]);

  const _submit = (_form) => {
    const __form = {
      financeAccountIdx: accountInfo.idx,
      userId: _form.userId,
      userPw: _form.userPw,
      employeeIdx: get(_form, 'employee[0].idx', null)
    }

    if (mode === "create") {
      systemAlert(`홈택스 직원을 등록하시겠습니까?`, {

        buttons: [
          {
            color: 'text',
            label: '취소'
          },
          {
            label: '승인',
            onClick: () => {
              viewLoading(true);
              createFinanceAccountSub(__form)
                .then((res) => {
                  toast.success('등록되었습니다.');
                  close();
                  submit && submit();
                })
                .finally(() => {
                  viewLoading(false);
                });
            }
          }
        ]
      });
    } else if (mode === "modify") {
      systemAlert(`홈택스 부서사용자를 수정 하시겠습니까?`, {
        buttons: [
          {
            color: 'text',
            label: '취소'
          },
          {
            label: '승인',
            onClick: () => {

              viewLoading(true);
              putFinanceAccountSub(formData.idx, __form)
                .then((res) => {
                  toast.success('수정되었습니다.');
                  close();
                  submit && submit();
                })
                .finally(() => {
                  viewLoading(false);
                });
            }
          }
        ]
      });
    }
  };

  const {
    form,
    errors,
    setValidateFields,
    setForm,
    handleOnChange,
    handleSubmit,
    resetForm,
  } = useForm(
    defaultForm,
    _submit,
  );

  useEffect(() => {
    setValidateFields(fields);
  }, [fields]);

  useEffect(() => {

    // 데이터 밖에서 주입받는 경우
    if (!isEmpty(formData)) {
      setForm({
        ...formData,
        employee: employees.filter((e) => e.idx === formData.employeeIdx)
      });
    }

    setMode(mode);
    if (mode === "create" || mode === "modify") {
      setButtons([
        {
          label: "닫기",
          color: 'text',
          onClick: close
        },
        {
          label: mode === "create" ? "생성하기" : "수정",
          onClick: handleSubmit,
        },
      ]);
    } else if (mode === "view" && isFunction(setMode)) {
      setButtons([
        {
          label: "닫기",
          color: 'text',
          onClick: close,
        },
        // {
        //   label: "수정 화면 이동",
        //   onClick: () => {
        //     setMode("modify");
        //     setIsModeChange(true);
        //   }
        // },
      ]);
    }
  }, [formData, mode, employees]);


  return (
    <Modal
      isOpen={open}
      close={close}
    >
      <div className="client-write">
        <ModalHeader>
          <Icon
            style={{ verticalAlign: 'top' }}
            src={SingoSettingIcon}
            width="40px"
            height="40px"
          />&nbsp;
          홈택스 직원 {mode === 'create' && "생성"}
          <small style={{ display: 'block', fontSize: '12px' }}>각 항목의 툴팁을 꼭 확인하여 사용법을 숙지 해주세요.</small>
        </ModalHeader>
        <Form
          mode={mode}
          isRequiredShow={true}
          fields={fields}
          form={form}
          onChange={handleOnChange}
          // submit={handleSubmit}
          // cancelText={'닫기'}
          // cancel={close}
          errors={errors}
          buttons={buttons}
        />
      </div>
    </Modal>
  );
};


export default TaxAccountSubHometax;
